import { render, staticRenderFns } from "./zhiboclassxq.vue?vue&type=template&id=385b2a92&scoped=true"
import script from "./zhiboclassxq.vue?vue&type=script&lang=js"
export * from "./zhiboclassxq.vue?vue&type=script&lang=js"
import style0 from "./zhiboclassxq.vue?vue&type=style&index=0&id=385b2a92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b2a92",
  null
  
)

export default component.exports